module.exports = __webpack_public_path__ + "static/img/42畜牧.6441091.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/42畜牧.jpg
// module id = RRIK
// module chunks = 1